module.exports = __webpack_public_path__ + "static/media/gretchen.c6aa3a76.png";